<template>
  <div
    id="page"
    class="page"
  >
    <router-view></router-view>
  </div>
</template>

<script setup>
import { onBeforeMount } from 'vue';
import { useConfiguracionStore } from '../../stores/configuracion-general.js';
const configuracionStore = useConfiguracionStore();

onBeforeMount(async () => {
  configuracionStore.findAllConfiguracionesHTTP({ page: 0 });
});
</script>

<style scoped>
.page {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
